var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4412 21.8261L25.8166 10.5756C26.133 10.1931 26.2849 9.70089 26.2391 9.20667C26.1933 8.71244 25.9535 8.25651 25.5722 7.93871C25.1909 7.62091 24.6993 7.46714 24.2049 7.51108C23.7105 7.55503 23.2536 7.79309 22.9344 8.17316L15 17.695L7.06566 8.17316C6.74687 7.79163 6.28967 7.55225 5.7945 7.50759C5.29932 7.46293 4.80667 7.61665 4.42477 7.93499C4.04286 8.25332 3.80293 8.71023 3.75768 9.20535C3.71243 9.70047 3.86556 10.1933 4.18344 10.5756L13.559 21.8261C13.7352 22.037 13.9557 22.2067 14.2047 22.3231C14.4537 22.4396 14.7252 22.4999 15.0001 22.4999C15.275 22.4999 15.5465 22.4396 15.7955 22.3231C16.0445 22.2067 16.2649 22.037 16.4412 21.8261Z",
    fill: "#BF825A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.253ed4071d982c165bb9fbd5fb6534e2.svg";
export { ForwardRef as ReactComponent };